import Action from "./comps/Action";
import Header from "./comps/Header";
import Details from "./comps/Details";
import Text from "components/Table2/CellComps/Text";
import { useDispatch, useSelector } from "react-redux";
import Box from "./comps/Box";
import Info from "./comps/Info";
import { SetStateAction, useEffect, useState } from "react";
import { apiDeleteRemittances, apiGetRemittance } from "../../../api/remittanceApi";
import { useNavigate } from "react-router-dom";
import { addOpenDrawer } from "../../../store/actions/appAction";
import EditImg from "assets/images/Edit.svg";
import DeleteImg from "assets/images/Delete.svg";
import {
  apiCreateNotifications,
  apiDeleteNotifications,
  apiEditNotifications,
  apiGetItemNotifications,
} from "api/notificationApi";
import { Tab, Tabs } from "@mui/material";
import { apiGetHistory, apiGetItemNote } from "api/noteApi";
import { TabPanel } from "./FactorDrawer";
import DrawerHistory from "./comps/DrawerHistory";
import Table from "components/Table2";

const initialTable: TableProps = {
  headers: [{ label: "کالا" }, { label: "مقدار" }, { label: "شرح" }],
  cols: [
    { Comp: Text, key: "product" },
    {
      Comp: Text,
      key: "quantity",
      getValue: (item) => {
        return (
          <div className="flex items-center gap-2 ">
            <span className="text-xs text-dark-3">{item.unit}</span>
            <span className="text-sm font-bold text-dark-1" style={{ direction: "ltr" }}>
              {Math.abs(item.quantity)}
            </span>
          </div>
        );
      },
    },
    { Comp: Text, key: "description" },
  ],
  headerColor: "#fff",
  rows: [],
  withoutMenu: true,
};

export default function RemittanceDrawer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { drawerProps, anchor } = useSelector((state: any) => state).appReducer;

  const token = useSelector((state: any) => state).businessReducer.business?.token;

  const [remittance, setRemittance] = useState(drawerProps?.remittance);
  const [table, setTable] = useState(initialTable);

  useEffect(() => {
    if (remittance) {
      dispatch(
        // @ts-ignore
        apiGetRemittance(remittance.type_id ?? remittance.id, token, (remittanceObject: any) => {
          const newRemittance = { ...remittance, ...remittanceObject };
          renderTable(newRemittance);
          setRemittance(newRemittance);
        })
      );
      initialNote();
    }
  }, []);

  // modal state
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const [notificationsList, setNotificationList] = useState([]);
  const [noteList, setNoteList] = useState([]);
  // ===modal state

  // notification functions
  const handleDeleteNotification = (id: any) => {
    dispatch(
      // @ts-ignore
      apiDeleteNotifications(token, id, () => {
        dispatch(
          // @ts-ignore
          apiGetItemNotifications(
            token,
            remittance.type_id ?? remittance.id,
            "Bill",
            (value: SetStateAction<never[]>) => {
              setNotificationList(value);
            }
          )
        );
      })
    );
  };
  const handelChangeActive = (value: any) => {
    dispatch(
      // @ts-ignore
      apiEditNotifications(token, value?.id, value.active, () => {
        dispatch(
          // @ts-ignore
          apiGetItemNotifications(
            token,
            remittance.type_id ?? remittance.id,
            "Bill",
            (value: SetStateAction<never[]>) => {
              setNotificationList(value);
            }
          )
        );
      })
    );
  };

  const submitNotification = (value: any) => {
    dispatch(
      // @ts-ignore
      apiCreateNotifications(
        token,
        remittance.type_id ?? remittance.id,
        "Bill",
        value?.title,
        value?.description,
        value.fireDate,
        () => {
          dispatch(
            // @ts-ignore
            apiGetItemNotifications(
              token,
              remittance.type_id ?? remittance.id,
              "Bill",
              (value: SetStateAction<never[]>) => {
                setNotificationList(value);
              }
            )
          );
          handleCloseModal();
        }
      )
    );
  };
  //=== notification functions

  // tabs state
  const [value, setValue] = useState(0);
  // ===state
  // tab function
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  //===========

  // ===transaction
  const [History, setHistory] = useState([]);

  // ===

  const initialNote = () => {
    dispatch(
      // @ts-ignore
      apiGetItemNote(token, remittance.type_id ?? remittance.id, "Bill", (value: SetStateAction<never[]>) => {
        setNoteList(value);
      })
    );
    dispatch(
      // @ts-ignore
      apiGetHistory(token, remittance.type_id ?? remittance.id, "Bill", (value: SetStateAction<never[]>) => {
        setHistory(value);
      })
    );
  };

  if (!remittance) return <></>;

  const closeDrawer = () => dispatch(addOpenDrawer(false, undefined, anchor));
  const editRemittance = () => {
    closeDrawer();
    navigate(`/remittances/${remittance.type}/${remittance.type_id ?? remittance.id}`);
  };

  const deleteRemittance = () => {
    closeDrawer();
    dispatch(
      // @ts-ignore
      setConfirm("حذف حواله", () =>
        // @ts-ignore
        dispatch(
          // @ts-ignore
          apiDeleteRemittances([remittance.type_id ?? remittance.id], token, {
            key: remittance.type,
          })
        )
      )
    );
  };

  const actions = {
    menu: [
      {
        label: "ویرایش",
        icon: <img src={EditImg} alt="" />,
        onClick: editRemittance,
        show: true,
      },
      {
        Label: <span style={{ color: "#F42222", fontSize: "12px", fontWeight: 700 }}>حذف</span>,
        icon: <img src={DeleteImg} alt="" />,
        onClick: deleteRemittance,
        show: true,
      },
    ],
  };

  const details = [];
  remittance.date && details.push(`تاریخ ثبت: ${remittance.date}`);

  const renderTable = (accounting: any) => {
    const rows: any = [];

    accounting.Product_Bills.map((item: any) => {
      rows.push({
        product: item.Product?.title,
        quantity: item.quantity,
        description: item.description ?? "-",
        unit: item.unit,
      });
    });

    setTable({
      ...initialTable,
      rows,
    });
  };

  return (
    <div style={{ backgroundColor: "#FCFEFF", height: "100vh" }}>
      <Header heading={"حواله انبار"} id={`${remittance.accountingCode}`} />
      <Action
        actions={actions}
        side={
          <div>
            <Info
              title={remittance.type === "enter" ? "ورود به " : "خروج از "}
              info={remittance.Warehouse?.title}
            />
          </div>
        }
        withReminder
        fireDate={undefined}
        submitNotification={(value) => {
          submitNotification(value);
        }}
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        handleOpenModal={handleOpenModal}
        deleteItem={(id) => handleDeleteNotification(id)}
        updateNotification={(val) => handelChangeActive(val)}
        reminderData={notificationsList}
      />

      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
        <Tab label="خلاصه" {...a11yProps(0)} />
        <Tab label="تاریخچه" {...a11yProps(1)} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <div style={{ padding: "0px 32px", minWidth: "500px" }}>
          <Details details={details} />
          <Box>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
                <div style={{ display: "flex", gap: 20 }}>
                  <Info title="#" info={remittance.accountingCode} />
                  <Info title="توضیحات" info={remittance.description} />
                </div>
                <div style={{ display: "flex", gap: 20 }}>
                  {remittance?.Project && <Info title="پروژه" info={remittance.Project?.title} />}
                  {remittance?.Branch && <Info title="شعبه" info={remittance.Branch?.title} />}
                  {remittance?.delivery && <Info title="تحویل" info={remittance?.delivery} />}
                  {remittance?.transport && <Info title="حمل و نقل" info={remittance?.transport} />}
                </div>
              </div>
            </div>
          </Box>
        </div>

        <div style={{ padding: "16px 32px" }}>
          <Box>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "auto",
                position: "relative",
              }}
            >
              <Table {...table} />
            </div>
          </Box>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DrawerHistory
          title={"رسید و.حواله"}
          history={History}
          noteList={noteList}
          token={token}
          detail_type="Bill"
          id={remittance.type_id ?? remittance.id}
          refresh={() => {
            initialNote();
          }}
        />
      </TabPanel>
    </div>
  );
}
